import { getProjectHistory } from "../api/projectDetailsHttpClient";

export const useProjectHistoryGrid = (id: string) => {
  return { getProjectHistory: getProjectHistory(id) };
};
